var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"items":_vm.itemsComputed,"placeholder":_vm.isTeacher ? 'Filter by Student' : 'Select Course',"menu-props":{offsetY: true},"filled":"","hide-details":""},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }